/*
 * @Author: betwaym 848032671@qq.com
 * @Date: 2024-01-26 11:51:35
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2026-04-08 15:45:40
 * @FilePath: \mrc-ess-base-frontend\src\utils\sso\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue"
import http from "@/service/httpConfig.js"
import Keycloak from "keycloak-js"
import store from "@/store"
import i18n from "@/lang"
import AWSS3 from "@/utils/awss3" //AWS S3

import { getMenu } from "@/service/api/login.js"
import router from "@/router"
import Message from "@/components/Message/index"
import $ from "jquery"
import ls from "@/utils/Ls"
export const user = {
  set: (data) => {
    return new Promise(async (resolve, reject) => {
      await store.dispatch("set_sys_upload_type")
      await store.dispatch("set_userData", data)
      if (data && data.language)
        await store.commit("set_lang", {
          text: "",
          value: data.language,
        })
      await store.commit("set_currentCompany", data.org_level_uuid)
      await store.commit("set_currentCompanyClientUuid", data.clientUuid)
      resolve()
    })
  },
  updateToken: (token_info) => {
    return new Promise((resolve, reject) => {
      store.dispatch("set_token", token_info)
      ls.set("refresh-token", token_info.refreshToken, token_info.refresh_token_expires_in ? token_info.refresh_token_expires_in : undefined)
      resolve()
    })
  },
}
export const base = {
  client_info: () => {
    if (!ls.get("client-info")) return null
    return JSON.parse(ls.get("client-info")) //解密客户端信息
  },

  getUri: () => {
    return `${location.href.match(/((http(s)?):\/\/)?([-A-Za-z0-9+&@#%?=~_|!:,.;]+)/)[0]}${process.env.BASE_URL}`
  },
  getLocale: () => {
    let locale = ls.get("localeLanguage")
    if (locale === "zh-HK") return "hk"
    else return locale ? locale : "en"
  },
  clearCookies: () => {
    return new Promise((resolve, reject) => {
      var date = new Date()
      let Excludes = [] //排除某些cookie不清空
      date.setTime(date.getTime() - 10000)
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--; ) {
          if (Excludes.indexOf(keys[i]) == -1) document.cookie = keys[i] + "=; expire=" + date.toGMTString() + "; path=/"
        }
      }
      resolve()
    })
  },
  clearStorage: () => {
    const excludes_keys = ["base-client-code", "base-application-keycloak", "rememberMe", "client-logout-url", "localeLanguage"]
    return new Promise((resolve, reject) => {
      let namespace = ls.options.namespace
      let all_storage_keys = Object.keys(ls.storage).map((key) => {
        return key.replace(namespace, "")
      })
      all_storage_keys.forEach((e) => {
        if (!excludes_keys.includes(e)) ls.remove(e)
      })
      resolve()
    })
  },
  logoutWithFrame: (keycloak, url) => {
    return new Promise((resolve, reject) => {
      const frame_url = `${url}?client_id=${keycloak.clientId}&post_logout_redirect_uri=${encodeURIComponent(`${base.getUri()}login`)}&id_token_hint=${keycloak.idToken}&refresh_token=${
        keycloak.refreshToken
      }`
      location.href = frame_url
      resolve()
      // let iframe = document.createElement('iframe')
      // iframe.src = frame_url
      // iframe.height = 0
      // iframe.width = 0
      // iframe.id = 'doc_iframe'
      // iframe.onload = () => {
      //     if (document.getElementById('doc_iframe'))
      //         document.getElementById('doc_iframe').remove()
      //     resolve()
      // }
      // document.body.appendChild(iframe) //插入iframe
    })
  },
  getUserInfo: () => {
    return new Promise((resolve, reject) => {
      http
        .post("/api/sso/getInfo/v1", {})
        .then((res) => {
          if (res.data) {
            if (res.data.is_third_party_login) store.commit("SET_KEYCLOAK_ThirdPartyLogin", true) //第三方登录
            AWSS3._init({
              endpoint: res.data.endpoint,
              accessKeyId: res.data.access_key_id,
              secretAccessKey: res.data.secret_access_key,
              region: res.data.region,
              s3ForcePathStyle: true, // 对于 MinIO，通常需要设置为 true
              bucket: res.data.bucket_name, //桶
              expires: res.data.expires, //签名过期时间
            })
            user.set(res.data).then(() => {
              resolve(true)
            })
          } else {
            resolve(false)
          }
        })
        .catch((error) => {
          resolve(false)
        })
    })
  },
  getUserMenu: () => {
    function getLanguageAndUrl(arr) {
      arr.forEach((item) => {
        if (item.menus_tree && item.menus_tree.length > 0) {
          getLanguageAndUrl(item.menus_tree)
        } else {
          store.commit("setAllMenuUrlList", {
            url: item.url,
            // title: item.language_name
            title: item.menu_name,
            function_uuid: item.function_uuid,
          })
        }
      })
    }
    return new Promise(async (resolve, reject) => {
      const menus_tree = await getMenu({
        product_shortcode: "MMS",
      })
      // 设置菜单权限
      store.commit("setCurrentCopmpanyMenu", menus_tree.data)
      store.dispatch("set_languageList", store.state.lang)
      getLanguageAndUrl(store.state.currentCopmpanyMenu)
      if (menus_tree.data.length <= 0) {
        Message({
          text: i18n.t("message_noMenuList"),
          color: "rgba(0,0,0,0.78)",
        })
        resolve(false)
      } else {
        resolve(true)
      }
    })
  },
  getBaseInfo: () => {
    return new Promise(async (resolve, reject) => {
      // 请求当前公司的语言种类
      await store.dispatch("setCurrentCompanyLanguageList")
      // 这是请求回来的公司语言种类
      const currentCompanyLanguage = store.state.currentCompanyLanguage
      const is_default = currentCompanyLanguage.filter((item) => item.value == store.getters.lang)
      const currentCompanyDefaultLanguage = currentCompanyLanguage.filter((item) => item.is_default == 1)
      // 登录页选择的语言在用户语言种类里面，那就用登录选择的语言，反之，使用用户默认的语言;
      if (currentCompanyLanguage.length <= 0) {
        store.commit("newsTips", i18n.t("message_accountHasNotLanguage"))
        resolve(false)
      }
      is_default.length > 0
        ? store.commit("set_lang", {
            text: is_default[0].text,
            value: is_default[0].value,
          })
        : store.commit("set_lang", {
            text: currentCompanyDefaultLanguage.length > 0 ? currentCompanyDefaultLanguage[0].text : "",
            value: currentCompanyDefaultLanguage.length > 0 ? currentCompanyDefaultLanguage[0].value : "",
          })

      // 所有语言label和message等信息  // 这个获取全部语言的接口 我暂时注释掉，因为在进入登录界面的时候就获取了这个数据，数据比较大，影响登录的速度，故注释掉
      // await store.dispatch("set_languageList", store.state.lang)
      // 将所有的label国际化注入到 i18n 中
      const langs = Object.keys(store.state.languageList)
      const values = Object.values(store.state.languageList)
      langs.forEach((item, index) => {
        if (item != "code" || item != "status" || item != "msg") i18n.mergeLocaleMessage(item, values[index])
      })
      /***userType 人员角色类型：0=普通人员 1超级管理员 2.普通管理员 3.隐藏管理员 4.系统管理员 5普通人员、单位管理员 */

      // 登录的时候就获取 头部的公司下拉 单位管理员和员工有这个
      if (store.state.userData.userType == "2" || store.state.userData.userType == "3") {
        await store.dispatch("set_topcompanylist")
      }

      store.commit("set_loginStatus", true)

      resolve(true)
    })
  },
}
export const auth = {
  getClient: (client_code, remember = false) => {
    return new Promise((resolve, reject) => {
      if (!client_code) resolve(false)
      http
        .post("/api/sso/getClientInfo/v1", {
          client_short_code: client_code,
          business_type: "WEB",
        })
        .then((res) => {
          // res.data = {
          //     keycloak_realm: 'ess',
          //     keycloak_client_id: 'ess-web',
          //     keycloak_url: 'http://localhost:8090/'
          // }
          if (res.data) {
            var keycloak_realm = res.data.keycloak_realm
            var keycloak_url = res.data.keycloak_url
            var keycloak_client_id = res.data.keycloak_client_id
            if (keycloak_realm && keycloak_url && keycloak_client_id) {
              ls.set(
                "client-info",
                JSON.stringify(
                  Object.assign({
                    keycloak_realm: keycloak_realm,
                    keycloak_url: keycloak_url,
                    keycloak_client_id: keycloak_client_id,
                  }),
                ),
                86400 * 500,
              ) //有效期半天
              ls.set("client-logout-url", `${res.data.keycloak_url}/realms/${res.data.keycloak_realm}/protocol/openid-connect/logout`)
              if (remember) {
                ls.set("base-client-code", client_code)
                ls.set("rememberMe", remember)
              }
              resolve(res.data)
            } else {
              resolve(false)
            }
          } else {
            resolve(false)
          }
        })
        .catch((error) => {
          resolve(false)
        })
    })
  },
  login: (callback) => {
    return new Promise((resolve, reject) => {
      callback()
      var client_info = base.client_info()
      var locale = base.getLocale()
      if (client_info) {
        var keycloak = new Keycloak({
          realm: client_info.keycloak_realm,
          url: client_info.keycloak_url,
          clientId: client_info.keycloak_client_id,
          kc_locale: locale,
          locale: locale,
          ui_locales: locale,
        })
        try {
          keycloak
            .init({ onLoad: "login-required", checkLoginIframe: false, redirectUri: `${base.getUri()}login?ess_state=1`, kc_locale: locale, locale: locale, ui_locales: locale })
            .then((authenticated) => {
              if (authenticated) {
                store.commit("SET_KEYCLOAK", JSON.stringify(keycloak))
                user
                  .updateToken({
                    token: `${keycloak.tokenParsed.typ} ${keycloak.token}`,
                    token_expires_in: keycloak.tokenParsed.exp * 1000 - new Date().valueOf(),
                    refresh_token_expires_in: keycloak.refreshTokenParsed.exp * 1000 - new Date().valueOf(),
                    refreshToken: `${keycloak.tokenParsed.typ} ${keycloak.refreshToken}`,
                  })
                  .then(() => {
                    // 获取用户信息
                    base.getUserInfo().then((result) => {
                      if (result) {
                        base.getBaseInfo().then((resl) => {
                          if (resl) {
                            base.getUserMenu().then((resl) => {
                              if (resl) {
                                resolve(keycloak)
                              } else {
                                auth.logout(false)
                                resolve(false)
                              }
                            })
                          } else {
                            auth.logout(false)
                            resolve(false)
                          }
                        })
                      } else {
                        auth.logout(false)
                        resolve(false)
                      }
                    })
                  })
              }
            })
            .catch((error) => {
              // 網絡錯誤
              console.log(error)
              Message({
                text: "authentication error!!!",
              })
              auth.logout(false)
              resolve(false)
            })
        } catch (error) {
          resolve(false)
        }
      } else {
        resolve(false)
      }
    })
  },
  refresh: () => {
    return new Promise((resolve, reject) => {
      const keycloak = JSON.parse(ls.get("base-application-keycloak"))
      if (keycloak && keycloak.updateToken) {
        keycloak.updateToken(-1).success(() => {
          const keycloak = store.getters.keycloak
          user
            .updateToken({
              token: `${keycloak.tokenParsed.typ} ${keycloak.token}`,
              token_expires_in: keycloak.tokenParsed.exp * 1000 - new Date().valueOf(),
              refresh_token_expires_in: keycloak.refreshTokenParsed.exp * 1000 - new Date().valueOf(),
              refreshToken: `${keycloak.tokenParsed.typ} ${keycloak.refreshToken}`,
            })
            .then((e) => {
              resolve(true)
            })
        })
      } else {
        resolve(false)
      }
    })
  },

  logout: (redirect = true) => {
    return new Promise((resolve, reject) => {
      const keycloak = JSON.parse(ls.get("base-application-keycloak"))
      const is_third_party_login = ls.get("base-application-isThirdPartyLogin")
      const url = ls.get("client-logout-url")
      if (keycloak && url) {
        // Vue.prototype.$mitt.emit('logout-start', true);
        // const url = client_info.keycloak_url + "/realms/" + client_info.keycloak_realm + "/protocol/openid-connect/logout"
        // const url = "https://sso.kaifa000.com/realms/essence/protocol/openid-connect/logout"
        // 登出
        location.href = `${url}?client_id=${keycloak.clientId}&post_logout_redirect_uri=${encodeURIComponent(`${base.getUri()}login`)}&id_token_hint=${keycloak.idToken}&refresh_token=${
          keycloak.refreshToken
        }`
        resolve()

        // 是否第三方登录
        // if(is_third_party_login){
        //     base.logoutWithFrame(keycloak, url).then(() => {
        //         Vue.prototype.$mitt.emit('logout-end', true)
        //         resolve()
        //     })
        // }else
        // $.ajax({
        //     url: encodeURI(url),
        //     method: 'GET',
        //     type: 'GET',
        //     data: {
        //         "client_id": keycloak.clientId,
        //         // "post_logout_redirect_uri": encodeURIComponent(`${base.getUri()}login`),
        //         "id_token_hint": keycloak.idToken,
        //         "refresh_token": keycloak.refreshToken
        //     },
        //     crossDomain: true,
        //     success: function (res, f, response) {
        //         Vue.prototype.$mitt.emit('logout-end', true)
        //         resolve()
        //     },
        //     complete: function (res) {
        //         if (res.status == 200) {
        //             Vue.prototype.$mitt.emit('logout-end', true)
        //             resolve()
        //         }
        //     },
        //     error: function (err) {
        //         base.logoutWithFrame(keycloak, url).then(() => {
        //             Vue.prototype.$mitt.emit('logout-end', true)
        //             resolve()
        //         })
        //     }
        // });
      } else {
        resolve()
      }
    })
      .then(() => {
        base.clearStorage().then(() => {
          base.clearCookies().then(() => {
            ls.set("client-info", null)
            ls.set("base-application-keycloak", null)
            if (redirect)
              router.push({
                path: "/login",
              })
          })
        })
      })
      .catch(() => {
        //    MESSAGE
        Message({
          text: "logout fail!!!",
        })
      })
  },
}
